<template>
  <div class="number">
    <p class="number-text">
      <img src="@/assets/images/step.svg" alt="STEP" />
    </p>
    <p class="number-0">
      <img src="@/assets/images/0.svg" alt="0" />
    </p>
    <div class="number-num" :class="`number-num-now-${number + 1}`">
      <p class="number-num-child number-num-1"><img src="@/assets/images/1.svg" /></p>
      <p class="number-num-child number-num-2"><img src="@/assets/images/2.svg" /></p>
      <p class="number-num-child number-num-3"><img src="@/assets/images/3.svg" /></p>
      <p class="number-num-child number-num-4"><img src="@/assets/images/4.svg" /></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SortSelectNumber',
  props: {
    number: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.number {
  display: flex;
  align-items: flex-end;
  padding: 20/375 * 100% 20/375 * 100% 0 0;
  position: absolute;
  top: 0;
  right: 0;
  @include media() {
    padding: 30px 35px 0 0;
  }
  &-text {
    width: 30/375 * 100vw;
    margin-right: 6/375 * 100vw;
    margin-bottom: 3/375 * 100vw;
    @include media() {
      width: 42px;
      margin-right: 16px;
      margin-bottom: 2px;
    }
  }
  &-0 {
    width: 12/375 * 100vw;
    @include media() {
      width: 19px;
    }
  }
  &-num {
    width: 12.75/375 * 100vw;
    height: 100%;
    position: relative;
    &-child {
      position: absolute;
      bottom: 0;
      transform: translateY(-100%);
    }
    &-1 {
      width: 6/375 * 100vw;
      left: 4/375 * 100vw;
      @include media() {
        width: 10px;
        left: 4px;
      }
      .number-num-now-1 & {
        opacity: 1;
        transform: translateY(0);
        transition: transform .45s ease .1s, opacity .35s ease;
      }
      .number-num-now-3 &,
      .number-num-now-4 & {
        opacity: 0;
        transform: translateY(100%);
      }
    }
    &-2 {
      width: 11.2/375 * 100vw;
      left: 3/375 * 100vw;
      @include media() {
        width: 18px;
        left: 4px;
      }
      .number-num-now-2 & {
        opacity: 1;
        transform: translateY(0);
        transition: transform .45s ease .1s, opacity .35s ease;
      }
      .number-num-now-4 & {
        opacity: 0;
        transform: translateY(100%);
      }
    }
    &-3 {
      width: 10.4/375 * 100vw;
      left: 3/375 * 100vw;
      @include media() {
        width: 17px;
        left: 4px;
      }
      .number-num-now-1 & {
        opacity: 0;
        transform: translateY(-100%);
      }
      .number-num-now-3 & {
        opacity: 1;
        transform: translateY(0);
        transition: transform .45s ease .1s, opacity .35s ease;
      }
    }
    &-4 {
      width: 12.75/375 * 100vw;
      left: 3/375 * 100vw;
      @include media() {
        width: 20px;
        left: 4px;
      }
      .number-num-now-1 &,
      .number-num-now-2 & {
        opacity: 0;
        transform: translateY(-100%);
      }
      .number-num-now-4 & {
        opacity: 1;
        transform: translateY(0);
        transition: transform .45s ease .1s, opacity .35s ease;
      }
    }
    &-now-1 &-2,
    &-now-2 &-3,
    &-now-3 &-4 {
      opacity: 0;
      transform: translateY(-100%);
      transition: transform .45s ease .1s, opacity .35s ease .1s;
    }
    &-now-2 &-1,
    &-now-3 &-2,
    &-now-4 &-3 {
      opacity: 0;
      transform: translateY(100%);
      transition: transform .45s ease .1s, opacity .35s ease .1s;
    }
  }
}
</style>
